import React, {Component} from 'react';

import { Theme } from '@mui/material/styles';

import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar'; 
//import Avatar from '@mui/material/Avatar';
import Toolbar from '@mui/material/Toolbar';
// import Accordion from '@mui/material/Accordion';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import {grey} from '@mui/material/colors';
// import HelpIcon from '@mui/icons-material/HelpOutline';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// //import UserIcon from '@mui/icons-material/Person';
// import InfoIcon from '@mui/icons-material/Info';
// import ConfIcon from '@mui/icons-material/Settings';
// //import StatIcon from '@mui/icons-material/PieChart';
// import MasterGrid from '../../components/layout/DynamicGrid';
import {helppost,apidownload} from '../../ajax';
// import { extendedstyles } from '../appstyles';
// import Button from '@mui/material/Button';
import {CenterGrid} from '../../components/layout';
import { Box } from '@mui/material';


const s:any ={
  MuiPaperroot:{
    width:400
  },
  helpform: {
    p: 1,
    width: '100%',
  },
  titlebar: {
    color: 'white',
    textALign: 'center',
    flex:1
  },
  summarybar: {
    backgroundColor: grey['100'],
  },
  formControl: {
    m: 1,
  },
  input: {
    m: 1,
  },
  actionbox: {
    display: 'flex',
    justifyContent: 'center'
  },
  action: {
    margin: 'auto 5px',
  },
  button: {
    m: 1,
  },
  leftIcon: {
    ml: -1,
    mr: 1,
  },
  avatarIcon: {
    float: 'left',
    display: 'block',
    marginRight: 15,
    boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.2)'
  },
  titletext: {

  },
  textField: {
    ml: 1,
    mr: 1,
    //width: 400,
  },
  details:  {
    width: '100%',
  },
  menu: {
    //width: 200,
  },
  hide: {
    display:'node'
  },
  show: {
    display:'inline-block'
  },
  logo: (theme:Theme)=> ({
    cursor: 'pointer',
    fontSize: 22,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightLight,
    backgroundImage: 'url(lib/img/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
    paddingLeft: 5,
    paddingRight: 5,
    height: 40,
    width:35,
    [theme.breakpoints.down('sm')]:{
      display:'none',
    },
  }),
  help:{
    margin: 20
  }
  
};

class Help extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      loading: false,
      count: 0,
      open: false,
      sbopen: false,
      sbmesg: '',
      username: '',
      password:'',
      showPassword: false,
      context: props.context,
      serviceid: 1,
      remember: false
    };
  }

  componentDidMount(){
    //this.loadhelp('main')();
  }

  loadhelp = (name:any) => () => {

  }

  load = async() => {
    console.log('starting onSubmit... ');
    const {code,service,mode,sconfig,record,onResponse,ft,ms,mt} = this.props;
    const {url,endpoint} = sconfig || {};
    const {formData} = this.state;
    //console.log('onsubmit.formdata:',formData);
    try{
      let s = service;
      let a = mode;
      let recs = (mode==='delete')?{rid:+(record.rid),stp:record.stp}:record;
      let params = Object.assign(recs,formData,{s,a,ft,ms,mt});
      //console.log('service request ',params);
      this.startLoading();
      const response:any = await helppost(params);
      //console.log('service response ',response);

      if (response.success){
        this.props.showNotification(response.sm,'success',response.st)
        onResponse(true,response);
      }
      else if(response.failure){
        if (response.en===60){
        }
        else{
          this.props.showNotification(response.message,response.type||'error',response.title)
        }
      }      
    }
    catch(err){
      const error:any = err || {};
      console.log('submit.error:',JSON.stringify(error));
      this.props.showNotification(error.message||"request failed",error.type||'warn',error.title||'Update Error');
    }
    finally{
      this.stopLoading();
    }
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  onChange = (panel:any) => (expanded:any) => {
    this.setState((prev:any) => ({expanded:expanded?panel:null}));
  }

  onDownload = () => {
    let url = '/api/download/';
    let doc = 'user_guide.pdf';
    // const response:any = await apidownload(doc,url,auth,);


  }

  render() {
    //const {service,code,showNotification,setPage,setHome,classes, theme} = this.props;
    const {userData,classes, theme} = this.props;
    //const unm = (userData.bd||{}).unm;
    const {expanded}  = this.state;
    const logosrc = '/api/logo/icon.png';
    const docsrc = '/api/download/';

    return (
      <CenterGrid>
        <Paper elevation={3} square={false}>
        <AppBar position="static">
          <Toolbar>
            <Box sx={{...s.logo}} style={{backgroundImage: `url(${logosrc})`}}/>
            <Typography variant="h3" sx={{...s.titlebar}}>
              Help
            </Typography>
          </Toolbar>
        </AppBar>
          <Box>
          <Box component='form' sx={{...s.helpform}}>
            
            <Box>
              <Typography>
                SCSMS 1.0
              </Typography>
            </Box>
            <Box>
              <Typography>
                Sales and Customer Management System
              </Typography>  
            </Box>
            <Box>
              <Typography>
                Customers, quotations, orders, invoicing, payments, stock and approvals
              </Typography> 
            </Box>
            <br/>
            <Box>
              <Typography>
              <Box component='a' href={docsrc} download="user_guide.pdf">Download SCSMS Guide</Box>
              </Typography> 
            </Box>
          </Box>
          </Box>
        </Paper>
        <Box>
          
        </Box>
      </CenterGrid>
    );

  }

  
}

export default Help;
